import React                      from 'react'
import { Observer }               from 'mobx-react'
import { Table }                  from 'antd'


import { TEXT
       , tr }                     from '../00_assets'
import { numerically_asc }        from '../01_core'
import { kde_api_machine_t }      from '../02_api'
import { MApp }                   from '../09_model_app'
import { avoid_closing_modal
       , EditButtons
       , ModalPrompt
       , TableState }             from '../10_ui'


import { MWorkGroups }            from './01_screen_workgroups_model'
import { create_machine_editor_model
       , MachineEditor }          from './05_screen_machines_editor'

export const WorkgroupMachinesTable: React.FC = () =>
<Observer render={ ( ) =>
{
  const model = MWorkGroups.instance( )
      , src   = model.machines.data_for_page( 0 ) ;

  return <MachinesTable
           loading={ src.loading }
           machines={ src.data.slice( 0 ) }
           onDelete={ model.machines.on_delete }
           onEdit={ model.machines.on_edit }
         />
} }/>


export const MachinesTable: React.FC<
   { machines: kde_api_machine_t[]
   , onDelete: ( user: kde_api_machine_t ) => any
   , onEdit: ( user: kde_api_machine_t, new_values: Partial< kde_api_machine_t > ) => any
   , loading: boolean
//   , buttonsDisabled: boolean
   } > = ( props ) =>
{
  const table_state = TableState( ) ;

  return <Observer render={ ( ) =>
  {
    const row_key  = ( row: kde_api_machine_t ) => row.id + ''
        , can_edit = MApp( ).can_edit_workgroups
        , on_edit  = (row: kde_api_machine_t) => ( ) =>
          {
            const editor_model = create_machine_editor_model( row ) ;

            ModalPrompt( tr( TEXT.WORKGROUPS_EDIT_TITLE )
                      , <MachineEditor form={ editor_model } editing={ true } />
                      , ( ) => 
                        {
                          if ( editor_model.has_errors( ) )
                               avoid_closing_modal( ) ;
                          else
                               props.onEdit( row, editor_model.fields( ) )
                        }
                      ) ;
          }
        , row_className = ( ) => "on-hover"
        , columns = [ { title: tr( TEXT.UI_NAME )
                      , dataIndex: 'name'
                      , ...table_state.sort_col( 'name'
                                               , (row: kde_api_machine_t) => row.name )
                      , width: '40%'
                      }
                    , { title: tr( TEXT.MACHINE_SERIAL_NO )
                      , dataIndex: 'serialNo'
                      , ...table_state.sort_col( 'serial_no'
                                               , (row: kde_api_machine_t) => row.serialNo )
                      }
                    , { title: tr( TEXT.MACHINE_TYPE )
                      , ...table_state.sort_col( 'type'
                                               , (row: kde_api_machine_t) => row.type.name )
                      , render: ( row: kde_api_machine_t ) => <span>{ row.type.name }</span>
                      }
                    , { title: tr( TEXT.MACHINE_NUM_JOBS )
                      , ...table_state.sort_col( 'num_jobs'
                                               , (row: kde_api_machine_t) => row.jobs!.length
                                               , numerically_asc )
                      , render: ( row: kde_api_machine_t ) => <span>{ row.jobs!.length }</span>
                      }
                    , { title: ''
                      , key: 'actions'
                      , render: ( row: kde_api_machine_t ) =>
                              can_edit? 
                                <EditButtons
                                  row={ row }
                                  onEdit={ on_edit( row ) }
                                  onDelete={ props.onDelete }
                                />
                              : null
                      , width: '95px'
                      }
                    ] ;


    return <Table
            className="m-3 shadow"
            loading={ props.loading }
            columns={ columns }
            dataSource={ props.machines }
            pagination={ false }
            rowKey={ row_key }
            rowClassName={ row_className }
            onChange={ table_state.on_table_change }
          /> ;
  } }/>
}


export function create_machine_modal ( callback: ( user: kde_api_machine_t ) =>  any, def_workgroup?: number | null )
{
  const cur_user     = MApp( ).user
      , editor_model = create_machine_editor_model( { workgroup: { id:   def_workgroup? def_workgroup
                                                                       : cur_user     ? cur_user.workgroup!.id
                                                                       :                0 }
                                                    , type: { id: 0 }
                                                    , serialNo: ''
                                                    , name: ''
                                                    } as any ) ;

  ModalPrompt( tr( TEXT.MACHINES_NEW )
              , <MachineEditor form={ editor_model } />
              , ( ) => 
                {
                  if ( editor_model.has_errors( ) ) 
                       avoid_closing_modal( ) ;
                  else
                       callback( editor_model.fields( ) as any )
                }
              , "plus"
              ) ;
}